export const categories = [
  {
    name: "Buty",
    nameEn: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageSeq: "cat-shoes-01",
  },
  {
    name: "Bluzy/Swetry",
    nameEn: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    imageSeq: "cat-hoodies-01",
  },
  {
    name: "T-Shirty",
    nameEn: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    imageSeq: "cat-tshirts-01",
  },
  {
    name: "Kurtki",
    nameEn: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    imageSeq: "cat-jackets-01",
  },
  {
    name: "Spodnie/Szorty",
    nameEn: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    imageSeq: "cat-pants-01",
  },
  {
    name: "Nakrycia głowy",
    nameEn: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    imageSeq: "cat-headwear-01",
  },
  {
    name: "Zestawy",
    nameEn: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    imageSeq: "cat-sets-01",
  },
  {
    name: "Bielizna",
    nameEn: "Underwear",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    imageSeq: "cat-underwear-01",
  },
  {
    name: "Koszulki sportowe",
    nameEn: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    imageSeq: "cat-jersey-01",
  },
  {
    name: "Akcesoria",
    nameEn: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    imageSeq: "cat-accessories-01",
  },
  {
    name: "Torby",
    nameEn: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    imageSeq: "cat-bags-01",
  },
  {
    name: "Paski",
    nameEn: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    imageSeq: "cat-belts-01",
  },
  {
    name: "Perfumy",
    nameEn: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    imageSeq: "cat-perfumes-01",
  },
  {
    name: "Inne",
    nameEn: "OtherStuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    imageSeq: "cat-other-01",
  },
];

export const testimonials = [
  {
    name: "Anna Kowalska",
    role: "Entuzjastka zakupów online",
    text: "Dzięki kakobuy spreadsheet udało mi się znaleźć najlepsze produkty w świetnych cenach. Lista produktów jest przejrzysta i regularnie aktualizowana. Polecam każdemu, kto robi zakupy z Chin!",
    avatarSeq: "avatar-anna",
  },
  {
    name: "Michał Nowak",
    role: "Kolekcjoner sneakersów",
    text: "Korzystam z kakobuy spreadsheet od miesięcy i zaoszczędziłem mnóstwo czasu. Porównanie agentów zakupowych jest bezcenne. To must-have dla każdego polskiego kupującego.",
    avatarSeq: "avatar-michal",
  },
  {
    name: "Katarzyna Wiśniewska",
    role: "Blogerka modowa",
    text: "Kakobuy spreadsheet to najlepsze narzędzie do organizacji zakupów. Polecam go wszystkim moim czytelnikom szukającym sprawdzonych dostawców i najlepszych okazji.",
    avatarSeq: "avatar-kasia",
  },
  {
    name: "Piotr Zieliński",
    role: "Przedsiębiorca e-commerce",
    text: "Jako sprzedawca internetowy regularnie korzystam ze spreadsheetów zakupowych. Ten od Kakobuy jest jednym z najlepszych — czysty układ, dokładne informacje, świetna organizacja.",
    avatarSeq: "avatar-piotr",
  },
  {
    name: "Magdalena Adamczyk",
    role: "Studentka",
    text: "Znalazłam kakobuy spreadsheet przez przypadek i to był strzał w dziesiątkę! Oszczędzam sporo na zakupach, a jakość produktów jest dokładnie taka jak w opisie.",
    avatarSeq: "avatar-magda",
  },
];

export const mainSiteUrl = "https://kaspreadsheet.com/";